import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import DateInput from "../../Components/Inputs/DateInput";
import EmailInput from "../../Components/Inputs/EmailInput";
import PasswordInput from "../../Components/Inputs/PasswordInput";
import SelectInput from "../../Components/Inputs/SelectInput";
import ImageInput from "../../Components/Inputs/ImageInput";

export default function ({ register, errors, control, data }) {
  return (
    <>
      <ImageInput
       label="Avatar"
       name="avatar"
       parentClasses="col-md-12"
       classes="d-inline-block"
       id = "avatarUploadId"
       register={register}
       control={control}
       errorMessage={errors?.avatar}
      />
      <TextInput
        label="First Name"
        name="first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.first_name}
      />
      <TextInput
        label="Last Name"
        name="last_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.last_name}
      />
      <TextInput
        label="Phone"
        name="phone"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.phone}
      />
      <DateInput
        label="Birthday"
        name="birthday"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.birthday}
      />
      <TextInput
        label="Personal Number"
        name="personal_number"
        parentClasses="col-md-6"
        register={register}
        errorMessage={errors?.personal_number}
      />
      <EmailInput
        label="Email"
        name="email"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.email}
        autoComplete='new-email'
      />
      <div className="py-5 my-5 border-top">
        <h4>Change Password</h4>
      </div>
      <PasswordInput
        label="Old Password"
        name="old_password"
        parentClasses="col-md-4"
        register={register}
        errorMessage={errors?.old_password}
        autoComplete='new-password'
      />
      <PasswordInput
        label="New Password"
        name="password"
        parentClasses="col-md-4"
        register={register}
        errorMessage={errors?.password}
      />
      <PasswordInput
        label="Confirm New Password"
        name="password_confirmation"
        parentClasses="col-md-4"
        register={register}
        errorMessage={errors?.password_confirmation}
      />
    </>
  );
}